import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthorizationData, TokenModel, TokenService } from 'src/api';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  token: string;
  refreshToken: string;

  cachedRequests: Array<HttpRequest<any>> = [];

  constructor(private tokenService: TokenService, private router: Router, private snackBar: MatSnackBar) {}

  setToken(token: string) {
    window.localStorage.setItem('token', token);
  }

  getToken() {
    return window.localStorage.getItem('token');
  }

  removeToken() {
    window.localStorage.removeItem('token');
    this.token = undefined;
  }

  setRefreshToken(refreshToken: string) {
    window.localStorage.setItem('refreshToken', refreshToken);
  }

  getRefreshToken() {
    return window.localStorage.getItem('refreshToken');
  }

  removeRefreshToken() {
    window.localStorage.removeItem('refreshToken');
    this.refreshToken = undefined;
  }

  isLoggedIn() {
    const token = this.getToken();
    return token !== null && token !== undefined && token !== '';
  }

  login(login: number, password: string) {
    return this.tokenService
      .getToken({
        login,
        password,
      })
      .pipe(
        tap(response => {
          this.setTokens(response);
        }),
        catchError(error => {
          this.snackBar.open(error, 'Ошибка', {
            duration: 5000,
          });

          return throwError(() => new Error('Ошибка при авторизации'));
        }),
      );
  }

  logout() {
    this.removeToken();
    this.removeRefreshToken();
    if (this.router && this.router.url.indexOf('returnUrl') === -1) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
    } else {
      window.location.href = '/login'; // #TODO use 'location.href' because the 'router' does not always exist
    }
  }

  collectFailedRequest(request: any) {
    this.cachedRequests.push(request);
  }

  retryFailedRequests() {
    // retry the requests. this method can
    // be called after the token is refreshed
  }

  getCode(phone: string, ls: number) {
    return this.tokenService.sendVerifyCode({ phone, koD_LSCH: ls }).pipe(
      catchError(error => {
        this.snackBar.open(error, 'Ошибка', {
          duration: 5000,
        });

        return throwError(() => new Error('Ошибка при получении кода'));
      }),
    );
  }

  registration(data: AuthorizationData) {
    return this.tokenService.getTokenByCode(data).pipe(
      tap(response => {
        this.setTokens(response);
      }),
      catchError(error => {
        this.snackBar.open(error, 'Ошибка', {
          duration: 5000,
        });

        return throwError(() => new Error('Ошибка при регистрации'));
      }),
    );
  }

  private setTokens(data: TokenModel) {
    this.token = data.token;
    this.refreshToken = data.refreshToken;
    if (this.token) {
      this.setToken(this.token);
    }
    if (this.refreshToken) {
      this.setRefreshToken(this.refreshToken);
    }
  }
}
